import { periodFormat } from 'utils/common';

export const createReqBody = filter => {
  return {
    filters: {
      search: filter.search ? filter.search : '*',
      sentimentDate: periodFormat(filter.sentimentDate),
      accountManager: filter.accountManager[0] ? filter.accountManager : '*',
      sentiment: filter.sentiment[0] ? filter.sentiment : '*'
    },
    sort: {
      fieldName: filter.fieldName,
      direction: filter.direction
    }
  };
};
